import React from 'react';
// Import Shared Components
import { Alert, Title } from 'shared-components';

function TransactionNotFound({ error }) {
  return <div>
    <Title>Payment Error</Title>
    <Alert type="danger">{error}</Alert>
  </div>;
}

export default TransactionNotFound;
